import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
  forwardRef,
  useImperativeHandle,
} from "react";
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Chip,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  FormControlLabel,
  FormGroup,
  Grid,
  Icon,
  IconButton,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  tableCellClasses,
} from "@mui/material";
import Select from "react-select";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import customStyles from "app/shared-components/SelectCustomStyle";
import { styled, useTheme, alpha } from "@mui/material/styles";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import data from "./data";
import AgGridTable from "../../utilities/AgGridTable";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { confirmAlert } from "react-confirm-alert";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import jwtDecode from "jwt-decode";
import {
  checkBlankSpace,
  checkSlashes,
  checkSpecialChar,
} from "../../utilities/FormValidation";
import { useNavigate } from "react-router-dom";
import ListPageHeader from "../../utilities/ListPageHeader";
import OrderSuccess from "./OrderSuccess";
import { AsyncPaginate } from "react-select-async-paginate";
import { uploadSingleFilePopup } from "../view-order/CustomCellEditor";
import { toast } from "react-toastify";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .ag-root-wrapper": {
      overflow: "inherit",
    },
    "& .ag-cell.custom-style": {
      backgroundColor: "rgb(33, 150, 243)",
      borderColor: "red",
    },
  },
  addButton: {
    position: "absolute",
    left: -55,
    top: 70,
    width: 46,
    height: 46,
  },
}));

const vendorOptions = [
  { value: "NOLTE ECO", label: "NOLTE ECO" },
  { value: "NOLTE KUECHEN", label: "NOLTE KUECHEN" },
  { value: "NOLTE NEO", label: "NOLTE NEO" },
  { value: "NOLTE SPA", label: "NOLTE SPA" },
];

const validTypes = [
  "image/jpeg",
  "image/png",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];

const reasonToPictureMap = (match) => {
  const map = {};
  return map[match];
};

const Action = (props) => {
  return (
    <>
      <Tooltip title={"Delete"}>
        <IconButton onClick={() => props.btnDelete(props.data)}>
          <FuseSvgIcon size={16} color="action">
            heroicons-solid:trash
          </FuseSvgIcon>
        </IconButton>
      </Tooltip>
    </>
  );
};

const ColorButton = styled(Button)(({ theme }) => ({
  color: `${theme.palette.secondary.contrastText} !important`,
  backgroundColor: theme.palette.secondary.main,
  padding: "5px 15px",
  borderRadius: "20px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  fontSize: "12px",

  "&:hover": {
    backgroundColor: theme.palette.secondary.dark,
  },

  "&[disabled]": {
    opacity: 0.4,
    background: theme.palette.action.disabledBackground,
    color: theme.palette.text.disabled,

    "& .file": {
      cursor: "not-allowed",
    },
  },

  "& .file": {
    opacity: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    cursor: "pointer",
  },
}));

const rangeUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findRanges}`;
const colorUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ranges}`;
const handleUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllHandlesByVendor}`;
const carcassUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllCarcassByVendor}`;
const newOrderUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.newCustomerOrder}`;
const searchAbNumberUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.searchOrderByAbNumber}`;
const searchCommissionUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.searchOrderByCommissionName}`;
const orderUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}api/getCaniasOrder`;
const uploadOrderFileUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.uploadOrderFile}`;
const downloadOrderFileUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.downloadOrderFile}`;
const newPartOrderUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.newPartOrder}`;
const aoRoReasonsUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.aoRoReasons}`;
const uploadUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.uploadPicture}`;
const companiesUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
const deleteFileUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.deleteFile}`;
const freightOptionUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.freightOptions}`;
const FileUploadCellRenderer = ({ updateCellData, rowIndex }) => {
  const [file, setFile] = useState(null);

  const handleFileChange = (event) => {
    const uploadedFile = event.target.files[0];
    setFile(uploadedFile);
    updateCellData(rowIndex, uploadedFile.name);
  };

  return (
    <div>
      <input type="file" onChange={handleFileChange} />
    </div>
  );
};

const PartOrder = (props) => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const [open, setOpen] = useState(false);
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const navigate = useNavigate();
  const [qtyValue, setQtyValue] = useState(1);
  const [rowData, setRowData] = useState([]);
  const [updateData, setUpdateData] = useState([]);
  const gridRef = useRef();
  const [partOrderValue, setPartOrderValue] = useState("exitingOrder");
  const [formOpen, setFormOpen] = useState(false);
  const [documentUpload, setDocumentUpload] = useState();
  const [documentFile, setDocumentFile] = useState([]);
  const [error, setError] = useState();
  const [invaildType, setInvalidFileType] = useState(false);
  const [formValues, setFormValues] = useState([
    {
      range: {},
      priceGroup: {},
      color: {},
      carcass: {},
      handle: {},
    },
  ]);
  const [freight, setFreight] = useState();
  const [SDFile, setSDFile] = useState(null);
  const [DRWFile, setDRWFile] = useState(null);
  const [sdFileId, setSdFileId] = useState("");
  const [drwFileId, setDrwFileId] = useState("");
  const [appliancesDetailFileId, setAppliancesDetailFileId] = useState("");
  const [orderCheckFileId, setOrderCheckFileId] = useState("");
  const [drawingFileId, setDrawingFileId] = useState("");
  const [appliancesDetail, setAppliancesDetail] = useState(null);
  const [orderCheckFile, setOrderCheckFile] = useState(null);
  const [drawingFile, setDrawingFile] = useState(null);
  const [sharedLater, setSharedLater] = useState(false);
  const [notApplicable, setNotApplicable] = useState(false);
  const [drwFileSupersedes, setDrwFileSupersedes] = useState(false);
  const [abNumberValue, setAbNumberValue] = useState("");
  const [selectedAbNumber, setSelectedAbNumber] = useState(null);
  const [searchCommission, setSearchCommission] = useState("");
  const [newCommissionName, setNewCommissionName] = useState("");
  const [selectedCommissionNumber, setSelectedCommissionNumber] =
    useState(null);
  const [abNumberOption, setAbNumberOption] = useState([]);
  const [commissionNumberOption, setCommissionNumberOption] = useState([]);
  const [defaultSelectedAbNumber, setDefaultSelectedAbNumber] = useState(null);
  const [defaultSelectedCommissionNumber, setDefaultSelectedCommissionNumber] =
    useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const pageSizeRef = useRef(0);
  const listRef = useRef(null);
  const [showroom, setShowroom] = useState(null);
  const [product, setProduct] = useState(null);
  const [productOptions, setProductOptions] = useState([]);
  const [orderCategoryValue, setOrderCategoryValue] = useState(null);
  const hiddenDRWFile = useRef(null);
  const hiddenADFile = useRef(null);
  const hiddenOrderCheckFile = useRef(null);
  const hiddenDrawingFile = useRef(null);
  const hiddenPictureFile = useRef(null);
  const [uploadValue, setUploadValue] = useState([{ uploadFile: null }]);
  const [getOrder, setGetOrder] = useState([]);
  const [range, setRange] = useState([]);
  const [color, setColor] = useState([]);
  const [priceGroup, setPriceGroup] = useState([]);
  const [handles, setHandles] = useState([]);
  const [carcass, setCarcass] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [customerName, setCustomerName] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [orderPlacementDate, setOrderPlacementDate] = useState("");
  const [orderLoadingDate, setOrderLoadingDate] = useState("");
  const [orderCategoryOptions, setOrderCategoryOptions] = useState([]);
  const [showroomOptions, setShowroomOptions] = useState([]);
  const [typeNumber, setTypeNumber] = useState("");
  const [orderReference, setOrderReference] = useState("");
  const [uniqueID, setUniqueID] = useState("");
  const [clientName, setClientName] = useState("");
  const [commissionName, setCommissionName] = useState();
  const [exitingCommissionName, setExitingCommissionName] = useState("");
  const [WG1Price, setWG1Price] = useState("");
  const [WG2Price, setWG2Price] = useState("");
  const [volume, setVolume] = useState();
  const [weight, setWeight] = useState();
  const [comment, setComment] = useState();
  const [validError, setValidError] = useState({});
  const [selectedRange, setSelectedRange] = useState({});
  const [btnDisable, setBtnDisable] = useState(true);
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [pictureId, setPictureId] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [reasonFile, setReasonFile] = useState(null);
  const [openSuccessOrder, setOpenSuccessOrder] = useState(false);
  const [currentOrder, setCurrentOrder] = useState([]);
  const [disableAddBtn, setDisableAddBtn] = useState(false);
  // const [imgUpldReqd, setImgUpldReqd] = useState(false);
  const [isReasonSelected, setIsReasonSelected] = useState(false);
  const [uploadFileName, setUploadFileName] = useState([]);
  const [loading, setLoading] = useState(false);
  const [checksubmit, setCheckSubmit] = useState(false);
  const [freightOptions, setFreightOptions] = useState([]);
  const [containerNo, setContainerNo] = useState();
  const [loadingWeek, setLoadingWeek] = useState();
  const [loadingWeekOptions, setLoadingWeekOptions] = useState([]);
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));

  const hasNolteSopRole = ["ROLE_ORDERPRO", "ROLE_SOPDIR"].some((role) =>
    token.scope.includes(role),
  );
  const hasSupperUser = [
    "ROLE_ADMIN",
    "ROLE_MD",
    "ROLE_ORDERPRO",
    "ROLE_SOPDIR",
  ].some((role) => token.scope.includes(role));

  const hasCustomerNos = [
    30152, 30153, 30154, 30155, 30156, 30157, 30158, 30159, 30160, 30161, 30162,
    30163, 30175,
  ];
  const [lastEdited, setLastEdited] = useState(null);
  const TOTAL_LENGTH = 21;
  const maxUniqueIdLength =
    TOTAL_LENGTH - clientName.length > 0 ? TOTAL_LENGTH - clientName.length : 0;

  const maxClientNameLength =
    TOTAL_LENGTH - uniqueID.length > 0 ? TOTAL_LENGTH - uniqueID.length : 0;
  const hasCustomerNo =
    hasCustomerNos.includes(token.company) ||
    token.scope.includes("ROLE_PARTNER_ADMIN");
  const GetReason = forwardRef((props, ref) => {
    const { data, colDef } = props;
    const refReasons = useRef();
    const [reasons, setReasons] = useState([]);
    const [selectedReasons, setSelectedReasons] = useState(
      data && data.reason
        ? {
            value: data.reasonId,
            label: data.reason,
            imgUpldReqd: data.imgUpldReqd,
            postnNumReqd: data.postnNumReqd,
          }
        : null,
    );

    const getAoReason = async () => {
      try {
        const list = await OAuthService.getList(aoRoReasonsUrl + `?size=1000`);
        const reasons = list.data?._embedded?.aoRoReasons || [];
        const options = reasons.map((item) => ({
          value: item.reasonId,
          label: item.reason,
          imgUpldReqd: item.imgUpldReqd,
          postnNumReqd: item.postnNumReqd,
          subReasons: item.subReasons || [],
        }));
        setReasons(options);
        return options;
      } catch (error) {
        toast.error(error.message);
      }
    };

    useEffect(() => {
      getAoReason();
    }, []);

    const handleChangeReason = (option) => {
      if (!option) {
        setIsReasonSelected(false);
        return;
      }
      if (colDef.field === "reason") {
        const reasonChanged = option.value !== data?.reasonId;
        const newData = {
          ...data,
          reasonId: option.value,
          imgUpldReqd: option.imgUpldReqd,
          postnNumReqd: option.postnNumReqd,
          subReasons: option.subReasons || [],
          subReason: reasonChanged ? "" : data?.subReason,
        };
        props.node.setData(newData);
      }
      setSelectedReasons(option);
    };

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          return selectedReasons?.label;
        },
      };
    });

    return (
      <Box className="w-full" style={{ width: 200 }}>
        <Select
          ref={refReasons}
          value={selectedReasons}
          options={reasons}
          onChange={handleChangeReason}
          className="w-full"
          menuPortalTarget={document.body}
          menuPosition="fixed"
          styles={{
            ...customStyles(),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menuList: (base) => ({
              ...base,
              maxHeight: "200px",
              overflowY: "auto",
            }),
          }}
        />
      </Box>
    );
  });
  const GetSubReason = forwardRef((props, ref) => {
    const { data } = props;
    const options = (data?.subReasons || []).map((s) => ({
      value: s,
      label: s,
    }));
    const [selected, setSelected] = useState(
      data?.subReason ? { value: data.subReason, label: data.subReason } : null,
    );

    useImperativeHandle(ref, () => ({
      getValue() {
        return selected?.value || "";
      },
    }));

    return (
      <Box className="w-full" style={{ width: 200 }}>
        <Select
          value={selected}
          options={options}
          onChange={(option) => setSelected(option)}
          isClearable
          autoFocus
          placeholder="Select sub category"
          className="w-full"
          menuPortalTarget={document.body}
          menuPosition="fixed"
          noOptionsMessage={() => "No sub category"}
          styles={{
            ...customStyles(),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menuList: (base) => ({
              ...base,
              maxHeight: "200px",
              overflowY: "auto",
            }),
          }}
        />
      </Box>
    );
  });
  const getFreightOptions = async () => {
    try {
      const list = await OAuthService.getList(freightOptionUrl);
      const freight = list?.data?.freightOptions?.map((value) => {
        return {
          label: `${value.shippingMethodName}`,
          value: value.shippingMethodName,
          id: value.code,
        };
      });
      setFreightOptions(freight);
    } catch (error) {
      console.log("error.message", error);
      toast.error(error.message);
    }
  };

  useEffect(() => {
    getFreightOptions();
  }, []);
  const CellCellEditorParams = forwardRef((props, ref) => {
    // console.log('UPLOAD', props)
    const { data, colDef, node } = props;
    const [pictureFile, setPictureFile] = useState("");

    const handlePictureUpload = async (e) => {
      const fileUploaded = e.target.files[0];
      setError();
      if (fileUploaded.size > 15000000) {
        toast.error("Please select file less than 15MB");
        return;
      }
      const formData = new FormData();
      formData.append("file", fileUploaded);
      try {
        const response = await OAuthService.uploadFile(uploadUrl, formData);
        setPictureFile(response.data.fileName);
        node.setDataValue("picture", response.data.fileName);
        const newData = { ...data.data, picture: response.data.fileName }; //, rowIndex: node.rowIndex
        if (
          (!newData.postnNumReqd || (newData.posNo && newData.postnNumReqd)) &&
          (!newData.imgUpldReqd ||
            (newData.picture.length > 0 && newData.imgUpldReqd))
        ) {
          setIsReasonSelected(true);
        } else {
          setIsReasonSelected(false);
        }
      } catch (error) {
        toast.error(error.message);
      }
    };

    useEffect(() => {
      if (props.data.picture) {
        setPictureFile(props.data.picture);
      }
    }, [props.data]);

    const removePictureFile = () => {
      //TODO Call delete file API to delete uploaded file on server
      setPictureFile("");
      if (data.imgUpldReqd) {
        setIsReasonSelected(false);
      }
    };

    useImperativeHandle(ref, () => {
      return {
        getValue() {
          const rowData = props.node;
          rowData.setDataValue("picture", pictureFile);
          return pictureFile;
        },
      };
    });

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        {!pictureFile && (
          <ColorButton
            variant="contained"
            component="label"
            disabled={pictureFile}
            sx={{
              width: "48px",
              height: "28px",
              padding: "4px 12px",
              cursor: "pointer",
            }}
          >
            <FuseSvgIcon size={16}>heroicons-outline:upload</FuseSvgIcon>
            <input
              type="file"
              className="file"
              onChange={handlePictureUpload}
              ref={hiddenPictureFile}
              disabled={pictureFile}
            />
          </ColorButton>
        )}
        {pictureFile && (
          <Box>
            <Chip
              label={pictureFile}
              title={pictureFile}
              onDelete={removePictureFile}
              sx={{
                height: "20px",
                maxWidth: "120px",

                "& .MuiChip-label": {
                  fontSize: "10px",
                  paddingLeft: "5px",
                  paddingRight: "5px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                },

                "& .MuiChip-deleteIcon": {
                  fontSize: "14px",
                  margin: "0 3px 0 -6px",
                  flexShrink: 0,
                },
              }}
            />
          </Box>
        )}
      </div>
    );
  });

  const [columnDefs, setColumnDefs] = useState([
    {
      field: "reason",
      editable: true,
      cellEditorPopup: true,
      cellEditor: GetReason,
      minWidth: 160,
      maxWidth: 250,
      singleClickEdit: true,
    },
    {
      field: "subReason",
      headerName: "Sub Category",
      minWidth: 160,
      singleClickEdit: true,
      cellEditorPopup: true,
      cellEditor: GetSubReason,
      editable: (params) => !!params.data?.subReasons?.length,
      cellClassRules: {
        "custom-style": (params) =>
          !!params.data?.subReasons?.length && !params.data?.subReason,
      },
    },
    { field: "subReasons", hide: true },
    {
      field: "posNo",
      headerName: "Pos. No.",
      minWidth:50,
      maxWidth: 90,
      editable: true,
      singleClickEdit: true,
      cellClassRules: {
        "custom-style": (params) => params.data.postnNumReqd,
      },
    },
    {
      field: "articleCode",
      headerName: "Article Code",
      editable: true,
      minWidth: 200,
      singleClickEdit: true,
    },
    {
      field: "picture",
      editable: true,
      // cellEditorPopup: true,
      cellEditor: CellCellEditorParams,
      singleClickEdit: true,
      // cellEditor: uploadSingleFilePopup,
      // cellRenderer: (data) => <CellCellEditorParams data={data} />,
      suppressPaste: true,
      maxWidth: 150,
      minWidth:100,
      cellClassRules: {
        "custom-style": (params) => params.data.imgUpldReqd,
      },
    },
    {
      field: "remark",
      cellEditor: "agLargeTextCellEditor",
      cellEditorPopup: true,
      editable: true,
      singleClickEdit: true,
      minWidth:60,
      cellEditorParams: {
        rows: 10,
        cols: 50,
        maxLength: 500,
      },
    },
    {
      cellRenderer: (data) => <Action data={data} btnDelete={onBtDeleteRow} />,
      minWidth: 50,
      maxWidth: 50,
      editable: false,
    },
    { field: "imgUpldReqd", hide: true },
    { field: "postnNumReqd", hide: true },
  ]);

  const onGridReady = (params) => {};

  const handleChangeOrderCategory = (event) => {
    setOrderCategoryValue({
      value: event.value,
      label: event.label,
    });
  };
  const handleQtyChange = (event) => {
    setQtyValue(Number(event.target.value));
  };
  const handlePartOrderChange = (event) => {
    setPartOrderValue(event.target.value);
    setShowroom("");
    setUniqueID("");
    setClientName("");
    setProduct("");
    setOrderCategoryValue("");
    setFormValues([
      {
        range: {},
        priceGroup: {},
        color: {},
        carcass: {},
        handle: {},
      },
    ]);
    setOrderCategoryOptions([]);
    setLoadingWeekOptions([]);
    setProductOptions([]);
    setShowroomOptions([]);
    setCustomerName("");
    setCustomerId("");
    setOrderReference("");
    setTypeNumber("");
    setDRWFile(null);
    setDrwFileId("");
    setAppliancesDetail(null);
    setAppliancesDetailFileId("");
    setOrderCheckFile(null);
    setOrderCheckFileId("");
    setDrawingFile(null);
    setUploadValue([{ uploadFile: null }]);
    setRowData([]);
    setFreight("");
    setLoadingWeek("");
    setComment("");
    setSelectedPartner("");
    setSelectedAbNumber(null);
    setSelectedCommissionNumber(null);
    setOrderPlacementDate("");
    setOrderLoadingDate("");
    setTypeNumber("");
    setOrderReference("");
    setWG1Price("");
    setWG2Price("");
    setContainerNo("");
    setSharedLater(false);
    setNotApplicable(false);
    setDrwFileSupersedes(false);
    setBtnDisable(true);
    hiddenDRWFile.current.value = null;
    hiddenADFile.current.value = null;
    hiddenOrderCheckFile.current.value = null;
    hiddenDrawingFile.current.value = null;
    setIsReasonSelected(false);
    setNewCommissionName("");
    setSelectedCommissionNumber(null);
    setDefaultSelectedCommissionNumber(null);
    setDisableAddBtn(false);
  };
  const filterLoadingWeekOptions = loadingWeekOptions.map((option, index) => ({
    ...option,
    isDisabled: sharedLater && index === 1,
  }));
  const onBtAdd = useCallback(
    (event) => {
      let newRow = {
        reason: "",
        posNo: "",
        articleCode: "",
        picture: "",
        remark: "",
        imgUpldReqd: false,
        postnNumReqd: false,
      };
      const newRowDate = gridRef.current.api.applyTransaction({
        add: [newRow],
      });
      const RowIndex = newRowDate.add[0].rowIndex;
      gridRef.current.api.refreshCells();
      setDisableAddBtn(true);
      setTimeout(() => {
        gridRef.current.api.setFocusedCell(RowIndex, "reason");
        gridRef.current.api.startEditingCell({
          rowIndex: RowIndex,
          colKey: "reason",
        });
      }, 0);
    },
    [rowData],
  );

  const onBtDeleteRow = useCallback(
    (event) => {
      const selectedRow = [event.node.data];
      rowData?.splice(event.node.rowIndex, 1);
      gridRef?.current?.api.applyTransaction({ remove: selectedRow });
      setDisableAddBtn(false);
      if (event.node.parent.allLeafChildren.length == 0) {
        setIsReasonSelected(false);
      }
    },
    [gridRef, rowData],
  );

  const getContextMenuItems = useCallback((event) => {
    const result = [
      {
        name: "Add",
        icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
        action: () => {
          onBtAdd(event);
        },
      },
      {
        name: "Delete",
        icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
        action: () => {
          onBtDeleteRow(event);
        },
      },
      "separator",
      "copy",
      // "export",
      // "chartRange",
    ];
    return result;
  }, []);
  const blockInvalidKeys = (e) => {
    if (["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  };
  const onCellValueChanged = useCallback(
    (params) => {
      const { data, colDef } = params;

      const model = {
        // id: data.id ? data.id : null,
        reason: data.reason,
        posNo: data.posNo,
        articleCode: data.articleCode,
        picture: data.picture,
        remark: data.remark,
        imgUpldReqd: data.imgUpldReqd,
        postnNumReqd: data.postnNumReqd,
        subReason: data.subReason,
        rowIndex: params.node.rowIndex,
      };
      //console.log('CELL DATA', data)
      if (
        updateData.filter((doc) => doc.rowIndex === params.node.rowIndex)
          .length > 0
      ) {
        const updatedData = updateData.map((item) => {
          if (item.rowIndex === params.node.rowIndex) {
            item.reason = data.reason;
            item.posNo = data.posNo;
            item.articleCode = data.articleCode;
            item.picture = data.picture;
            item.remark = data.remark;
            item.imgUpldReqd = data.imgUpldReqd;
            item.subReason = data.subReason;
            item.postnNumReqd = data.postnNumReqd;
          }
          return item;
        });
        setUpdateData(updatedData);
      } else {
        setUpdateData([...updateData, model]);
      }

      params.node.parent.allLeafChildren.forEach((node) => {
        let nodeData = node.data;
        if (
          nodeData.reason &&
          (!nodeData.postnNumReqd ||
            (nodeData.posNo && nodeData.postnNumReqd)) &&
          (!nodeData.imgUpldReqd ||
            (nodeData.picture.length > 0 && nodeData.imgUpldReqd)) &&
          (!nodeData.subReasons?.length || !!nodeData.subReason)
        ) {
          setIsReasonSelected(true);
          setDisableAddBtn(false);
        } else {
          setIsReasonSelected(false);
          setDisableAddBtn(true);
        }
      });
    },
    [updateData],
  );

  let addFormFields = () => {
    setFormValues([
      ...formValues,
      { range: {}, priceGroup: {}, color: {}, carcass: {}, handle: {} },
    ]);
  };

  let addUploadFields = () => {
    setUploadValue([...uploadValue, { id: "", uploadFile: null }]);
  };

  let removeFormFields = (i) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };
  const extractClientName = (commissionName, uniqueId) => {
    if (!commissionName) return null;
    let name = commissionName.trim();

    if (uniqueId && name.endsWith(`-${uniqueId}`)) {
      name = name.slice(0, -(uniqueId.length + 1));
    } else {
      name = name.replace(/-[^-]*$/, "");
    }

    const prefix = /^[A-Z]{2}\d+-?[A-Z]{2}-/;
    if (!prefix.test(name)) return null;

    return name.replace(prefix, "").trim();
  };
  const getNewOrder = async () => {
    let list;
    let newOrder;
    try {
      if (partOrderValue === "newOrder") {
        if (hasSupperUser) {
          if (selectedPartner) {
            list = await OAuthService.getList(
              newOrderUrl + `?customerId=${selectedPartner?.value}`,
            );
          }
          newOrder = list.data;
        } else {
          list = await OAuthService.getList(newOrderUrl);
          newOrder = list.data;
        }
        // let list = await OAuthService.getList(newOrderUrl);
        // let newOrder = list.data;
        const products = newOrder?.products.map((value) => {
          return {
            label: value.name,
            value: value.shortKey,
            id: value.id,
          };
        });
        const showrooms = Object.keys(newOrder?.showrooms).map((key) => ({
          value: key,
          label: newOrder.showrooms[key],
        }));
        const loadingWeek = Object.keys(newOrder?.loadingWeek).map((key) => ({
          value: key,
          label: newOrder.loadingWeek[key],
        }));
        // const filterOrderCategory = newOrder?.orderCategories.filter(
        //   (item) => item.name !== "SAM"
        // );
        const orderCategories = newOrder?.orderCategories.map((value) => {
          return { label: `${value.displayName}`, value: value.name };
        });
        setShowroom({
          value: newOrder?.showroomId,
          label: newOrder?.showroomName,
        });
        setOrderCategoryOptions(orderCategories);
        setLoadingWeekOptions(loadingWeek);
        setProductOptions(products);
        setShowroomOptions(showrooms);
        setCustomerName(newOrder?.companyName);
        setCustomerId(newOrder?.partnerCompany);
        setOrderReference(newOrder?.projectNum);
        setTypeNumber(newOrder?.typeNumber);
        setUniqueID(newOrder?.uniqueId === null ? "" : newOrder?.uniqueId);
        setClientName(
          newOrder?.clientName === null ? "" : newOrder?.clientName,
        );
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const getExitingOrder = async (selectedValue) => {
    try {
      setError();
      setCustomerName("");
      setExitingCommissionName("");
      setCustomerId();
      setShowroom();
      setProduct();
      setOrderCategoryValue();
      setDRWFile();
      setDrwFileId();
      setAppliancesDetail();
      setAppliancesDetailFileId();
      setOrderCheckFile();
      setOrderCheckFileId();
      setDrawingFile();
      setOrderPlacementDate("-");
      setOrderLoadingDate("-");
      setFormValues([
        { range: {}, priceGroup: {}, color: {}, carcass: {}, handle: {} },
      ]);

      let url = orderUrl;
      if (selectedValue) {
        url += `/${selectedValue.docType}?documentNo=${selectedValue.orderId}&itemNum=${selectedValue.itemNum}`;
      }

      const list = await OAuthService.getList(url);
      const getOrder = list.data;
      setGetOrder(getOrder);

      setExitingCommissionName(getOrder?.commissionName);

      setOrderReference(getOrder?.orderReference);
      setOrderCategoryValue({
        value: getOrder?.orderCategory,
        label: getOrder?.orderCategory,
      });

      if (hasCustomerNo) {
        let list = await OAuthService.getList(newOrderUrl);
        let newOrder = list.data;
        const showrooms = Object.keys(newOrder?.showrooms).map((key) => ({
          value: key,
          label: newOrder.showrooms[key],
        }));
        if (showrooms.length === 1) {
          setShowroom(showrooms[0]);
        } else {
          setShowroom({
            value: newOrder?.showroomId,
            label: newOrder?.showroomName,
          });
        }
        setCustomerName(newOrder?.companyName);
        setCustomerId(newOrder?.partnerCompany);
        if (getOrder?.showroomNo && getOrder?.showroom) {
          setShowroom({
            value: getOrder?.showRoomNo,
            label: getOrder?.showroom,
          });
        }
        setShowroomOptions(showrooms);
      } else {
        setCustomerName(getOrder?.customerName);
        setCustomerId(getOrder?.customerNo);
        setShowroom({
          value: getOrder?.showRoomNo,
          label: getOrder?.showroom,
        });
      }
      setProduct({
        value: getOrder?.vendorShortKey,
        label: getOrder?.vendorName,
        id: getOrder?.vendor,
      });
      setOrderCategoryValue({
        value: getOrder?.orderCategory,
        label: getOrder?.orderCategory,
      });
      setDRWFile(getOrder?.drwFile);
      setDrwFileId(getOrder?.drwFile?.id);
      setAppliancesDetail(getOrder?.applianceDetail);
      setAppliancesDetailFileId(getOrder?.applianceDetail?.id);
      setOrderCheckFile(getOrder?.orderCheckList);
      setOrderCheckFileId(getOrder?.orderCheckList?.id);
      setDrawingFile(getOrder?.drawingFile);
      const uniqueId = getOrder?.uniqueid;
      const isProject = ["CPRJ", "PRJ"].includes(getOrder?.orderCategory);

      setUniqueID(uniqueId);

      const extracted = isProject
        ? extractClientName(getOrder?.commissionName, uniqueId)
        : null;

      setClientName(extracted || getOrder?.client);
      const placeDate = getOrder?.orderPlcDate;
      let formattedDate = "Invalid Date";
      if (placeDate) {
        const placeDateObject = new Date(placeDate);
        const day = placeDateObject.getDate().toString().padStart(2, "0");
        const month = (placeDateObject.getMonth() + 1)
          .toString()
          .padStart(2, "0");
        const placedYear = placeDateObject.getFullYear();
        formattedDate = `${day}/${month}/${placedYear}`;
        setOrderPlacementDate(formattedDate);
      } else {
        setOrderPlacementDate("-");
      }
      const orderWeek = getOrder?.orderPlacedWk;
      if (placeDate && orderWeek) {
        const dateObject = new Date(placeDate);
        const year = dateObject.getFullYear();
        setOrderLoadingDate(`${getOrder?.orderPlacedWk}/${year}`);
      } else {
        setOrderLoadingDate("-");
      }
      const initialFormValues = [];
      for (let i = 1; i <= 3; i++) {
        const rangeKey = `range${i}`;
        const priceGroup = `priceGroup${i}`;
        const colorKey = `color${i}`;
        const carcassKey = `carcass${i}`;
        const handleKey = `handle${i}`;

        if (
          getOrder[rangeKey] ||
          getOrder[priceGroup] ||
          getOrder[colorKey] ||
          getOrder[carcassKey] ||
          getOrder[handleKey]
        ) {
          initialFormValues.push({
            range: getOrder[rangeKey]
              ? { label: getOrder[rangeKey], value: getOrder[`${rangeKey}Id`] }
              : null,
            priceGroup: getOrder[priceGroup]
              ? { label: getOrder[priceGroup], value: getOrder[priceGroup] }
              : null,
            color: getOrder[colorKey]
              ? {
                  label: getOrder[colorKey],
                  value: getOrder[colorKey].substring(
                    0,
                    getOrder[colorKey].indexOf("-"),
                  ),
                }
              : null,
            carcass: getOrder[carcassKey]
              ? {
                  label: getOrder[carcassKey],
                  value: getOrder[carcassKey].substring(
                    0,
                    getOrder[carcassKey].indexOf("-"),
                  ),
                }
              : null,
            handle: getOrder[handleKey]
              ? {
                  label: getOrder[handleKey],
                  value: getOrder[handleKey].substring(
                    0,
                    getOrder[handleKey].indexOf("-"),
                  ),
                }
              : null,
          });
        }
      }
      setFormValues(initialFormValues);
      return getOrder;
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
    }
  };
  console.log(clientName);
  const getAbNumber = async (query, page, size) => {
    setIsLoading(true);
    try {
      let url = searchAbNumberUrl;
      if (query) {
        url += `?query=${query}&page=${page}&size=${size}`;
      } else {
        url += `?page=${page}&size=${size}`;
      }
      let list = await OAuthService.getList(url);
      const data = list.data?.content;
      const filterData = data.filter((item) => item.abNumber !== null);
      return {
        options: filterData,
        hasMore: filterData.length >= 1,
        additional: {
          page: page + 1,
        },
      };
      // setAbNumberOption(filterData.map(ab => ({
      //   value: ab.orderId,
      //   label: ab.abNumber
      // })))
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getCommissionName = async (query, page, size) => {
    try {
      let url = searchCommissionUrl;
      if (query) {
        url += `?query=${query}&page=${page}&size=${size}`;
      } else {
        url += `?page=${page}&size=${size}`;
      }
      let list = await OAuthService.getList(url);
      const data = list.data?.content;
      return {
        options: data,
        hasMore: data.length >= 1,
        additional: {
          page: page + 1,
        },
      };
      // setCommissionNumberOption(data.map(ab => ({
      //   value: ab.orderId,
      //   label: ab.commissionName
      // })))
    } catch (error) {
      toast.error(error.message);
    }
  };

  const getRangeList = async () => {
    OAuthService.getList(`${rangeUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const ranges = list.data;
        setRange(
          ranges?.map((range) => ({
            value: range?.productId,
            label: `${range?.priceGroup?.pgId || "NA"}-${range?.productName}`,
            id: range.id,
            priceGroup: range?.priceGroup?.pgId,
          })),
        );
      })
      .catch((err) => toast.error(err.message));
  };

  const getHandleList = async () => {
    OAuthService.getList(`${handleUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const { handles } = list.data?._embedded;
        setHandles(
          handles?.map((handle) => ({
            value: handle.productId,
            label: `${handle.productId}-${handle.productName}`,
          })),
        );
      })
      .catch((err) => toast.error(err.message));
  };

  const getCarcassList = async () => {
    OAuthService.getList(`${carcassUrl}?vendorId=${product?.id}`)
      .then((list) => {
        const { carcasses } = list.data?._embedded;
        setCarcass(
          carcasses?.map((carcasse) => ({
            value: carcasse.productId,
            label: `${carcasse.productId}-${carcasse.productName}`,
          })),
        );
      })
      .catch((err) => toast.error(err.message));
  };

  useEffect(() => {
    if (selectedPartner || !hasSupperUser) {
      getNewOrder();
    }
  }, [partOrderValue, selectedPartner, hasSupperUser]);

  useEffect(() => {
    if (product) {
      getRangeList();
      getHandleList();
      getCarcassList();
    }
  }, [product]);

  const handleInputAbNumber = (option) => {
    setAbNumberValue(option);
    pageSizeRef.current = 1;
  };

  const handleInputCommission = (option) => {
    setSearchCommission(option);
    pageSizeRef.current = 1;
  };

  const handleAbNumberChange = async (option) => {
    // console.log("option", option);
    setError();
    setSelectedAbNumber(option);
    setSelectedCommissionNumber(null);
    setDefaultSelectedCommissionNumber(null);

    try {
      const getOrder = await getExitingOrder(option);
      const commissionName = getOrder?.commissionName;
      if (commissionName) {
        setDefaultSelectedCommissionNumber(option);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
    }
  };

  const handleCommissionChange = async (option) => {
    setError();
    setSelectedCommissionNumber(option);
    setSelectedAbNumber(null);
    setDefaultSelectedAbNumber(null);

    try {
      const getOrder = await getExitingOrder(option);
      const abNumber = getOrder?.abNumber;
      if (abNumber) {
        setDefaultSelectedAbNumber(option);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
    }
  };

  const removeDRWFile = async () => {
    try {
      await OAuthService.deleteData(deleteFileUrl, drwFileId);
      setSuccessMsg("File removed Successfully");
      setSnackState(true);
      hiddenDRWFile.current.value = null;
      setDRWFile(null);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const removeADFile = async () => {
    try {
      await OAuthService.deleteData(deleteFileUrl, appliancesDetailFileId);
      setSuccessMsg("File removed Successfully");
      setSnackState(true);
      hiddenADFile.current.value = null;
      setAppliancesDetail(null);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const removeOrderCheckFile = async () => {
    try {
      await OAuthService.deleteData(deleteFileUrl, orderCheckFileId);
      setSuccessMsg("File removed Successfully");
      setSnackState(true);
      hiddenOrderCheckFile.current.value = null;
      setOrderCheckFile(null);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const removeDrawingFile = async (index) => {
    try {
      await OAuthService.deleteData(deleteFileUrl, drawingFileId[index]);
      setSuccessMsg("File removed Successfully");
      setSnackState(true);
      hiddenDrawingFile.current.value = null;
      setDrawingFile(null);
      const filteredFiles = uploadValue;
      filteredFiles[index] = { id: "", uploadFile: {} };
      setUploadValue(() => [...filteredFiles]);
    } catch (error) {
      toast.error(error.message);
    }
  };
  let removeUploadFields = (i) => {
    let newUploadValue = [...uploadValue];
    newUploadValue.splice(i, 1);
    setUploadValue(newUploadValue);
  };
  const handleDRWUpload = async (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;
    if (fileUploaded) {
      const fileExtension = fileUploaded.name.split(".").pop().toLowerCase();
      if (fileExtension !== "drw" && fileExtension !== "prw") {
        toast.warning("Please upload a file with .drw or .prw extension");
        return;
      }
    }
    try {
      let payload = {
        file: [fileUploaded],
        customerId: customerId,
        commissionName: commissionName,
        isOriginal: true,
      };
      if (partOrderValue === "exitingOrder") {
        payload = { ...payload, commissionName: getOrder.commissionName };
      }
      const list = await OAuthService.addFiles(
        `${uploadOrderFileUrl}`,
        payload,
      );
      const data = list.data;
      const fileId = data.map((file) => file.id);
      setDrwFileId(fileId.join(""));

      setDRWFile(fileUploaded);
      const formData = new FormData();
      formData.append("File", DRWFile);
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
    }
  };
  const handleDownloadFile = async (fileId, fileName) => {
    const download = await OAuthService.getDownload(
      `${downloadOrderFileUrl}?orderAttachmentId=${fileId}`,
    );
    const blob = download?.data;
    if (blob) {
      const url = window.URL.createObjectURL(
        new Blob([blob], { type: "application/octet-stream" }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = `${commissionName || ""}-${fileName}`;
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  };
  const handleADUpload = async (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;
    try {
      let payload = {
        file: [fileUploaded],
        customerId: customerId,
        commissionName: commissionName,
        isOriginal: true,
      };
      if (partOrderValue === "exitingOrder") {
        payload = { ...payload, commissionName: getOrder.commissionName };
      }
      const list = await OAuthService.addFiles(
        `${uploadOrderFileUrl}`,
        payload,
      );
      const data = list.data;
      const fileId = data.map((file) => file.id);
      setAppliancesDetailFileId(fileId.join(""));
      setAppliancesDetail(fileUploaded);
      const formData = new FormData();
      formData.append("File", appliancesDetail);
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
    }
  };
  const handleOrderCheckUpload = async (e) => {
    const fileUploaded = e.target.files[0];
    if (!fileUploaded) return;
    try {
      let payload = {
        file: [fileUploaded],
        customerId: customerId,
        commissionName: commissionName,
        isOriginal: true,
      };
      if (partOrderValue === "exitingOrder") {
        payload = { ...payload, commissionName: getOrder.commissionName };
      }
      const list = await OAuthService.addFiles(
        `${uploadOrderFileUrl}`,
        payload,
      );
      const data = list.data;
      const fileId = data.map((file) => file.id);
      setOrderCheckFileId(fileId.join(""));

      setOrderCheckFile(fileUploaded);
      const formData = new FormData();
      formData.append("File", orderCheckFile);
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
    }
  };
  const handleDrawingUpload = async (e, index) => {
    const newUploadValue = [...uploadValue];
    newUploadValue[index].uploadFile = e.target.files[0];
    if (!newUploadValue) return;
    try {
      let payload = {
        file: e.target.files[0],
        customerId: customerId,
        commissionName: commissionName,
        isOriginal: true,
      };
      if (partOrderValue === "exitingOrder") {
        payload = { ...payload, commissionName: getOrder.commissionName };
      }
      const list = await OAuthService.addFiles(
        `${uploadOrderFileUrl}`,
        payload,
      );
      const data = list.data;
      const fileId = data.map((file) => file.id);
      setDrawingFileId((prevIds) => [...prevIds, fileId.join("")]);
      newUploadValue[index].id = data.map((file) => file.id)[0]; // e.target.files[0];
      setUploadValue(() => [...newUploadValue]);
    } catch (error) {
      toast.error(
        error?.response?.data?.errorMessage ||
          error?.response?.data ||
          error.message,
      );
    }
  };

  const handleUniqueIDChange = (e) => {
    const rawValue = e.target.value;
    const validationValue = rawValue.toUpperCase();

    const specialCharRegex = /^[a-zA-Z0-9()_\- ]*$/;
    if (!specialCharRegex.test(validationValue)) {
      toast.warn("Special characters are not allowed!");
      return;
    }

    const hasForwardSlash = validationValue.includes("/");
    const hasBackwardSlash = validationValue.includes("\\");
    if (hasForwardSlash || hasBackwardSlash) {
      let errorMessage = "Unique ID must not contain";
      if (hasForwardSlash) errorMessage += " '/'.";
      if (hasBackwardSlash) errorMessage += " '\\'.";
      toast.warn(errorMessage);
      return;
    }

    setUniqueID(rawValue);
    setLastEdited("uniqueID");
  };

  const handleClientNameChange = (e) => {
    const rawValue = e.target.value;
    const validationValue = rawValue.toUpperCase();
    const specialCharRegex = /^[a-zA-Z0-9()_\- ]*$/;
    if (!specialCharRegex.test(validationValue)) {
      toast.warn("Special characters are not allowed!");
      return;
    }

    const hasForwardSlash = validationValue.includes("/");
    const hasBackwardSlash = validationValue.includes("\\");
    if (hasForwardSlash || hasBackwardSlash) {
      let errorMessage = "Client Name must not contain";
      if (hasForwardSlash) errorMessage += " '/'.";
      if (hasBackwardSlash) errorMessage += " '\\'.";
      toast.warn(errorMessage);
      return;
    }

    setClientName(rawValue);
    setLastEdited("clientName");
  };

  const totalListPrice = () => {
    const number1 = parseFloat(WG1Price) || 0;
    const number2 = parseFloat(WG2Price) || 0;
    const sum = number1 + number2;
    return sum.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
  };

  const resetFormValues = () => {
    const set = [];
    formValues.map(() => {
      set.push({
        range: {},
        priceGroup: {},
        color: {},
        carcass: {},
        handle: {},
      });
    });
    setFormValues(() => [...set]);
  };

  const handleRangeChange = (data, index, field) => {
    const newVals = formValues; //[index];
    // console.log("handleRange data", data);
    newVals[index][field] = { value: data.value, label: data.label }; // data.value;
    setSelectedRange({ value: data.value, label: data.label, id: data.id });
    if (field === "range") {
      newVals[index]["color"] = {}; // data.value;
      newVals[index]["priceGroup"] = {
        value: data.priceGroup,
        label: data.priceGroup,
      }; // data.value;
      OAuthService.getList(`${colorUrl}/${data.id}/variations`)
        .then((list) => {
          const rangeVariations = list.data?._embedded?.rangeVariations;
          const colors = color;
          colors[index] = rangeVariations?.map((variations) => ({
            value: variations.productId,
            label: `${variations.productId}-${variations.productName}`,
          }));
          setColor((prev) => [...colors]);
        })
        .catch((err) => toast.error(err.message));
    }
    setFormValues((prev) => [...newVals]);
  };

  useEffect(() => {
    if (orderReference && typeNumber) {
      setCommissionName(
        `${orderReference}${typeNumber}${
          product?.value === undefined ? "" : product?.value
        }-${uniqueID}-${clientName}`.toUpperCase(),
      );
    }
  }, [orderReference, typeNumber, product, uniqueID, clientName]);

  useEffect(() => {
    if (partOrderValue === "exitingOrder" && exitingCommissionName) {
      const splitCommissionName = exitingCommissionName?.split("-");
      const regex = /^[A-Z]{2}\d{8}[A-Z]{2}$/;

      const newValue = regex.test(splitCommissionName[0])
        ? splitCommissionName[0]
        : `${splitCommissionName[0]}-${splitCommissionName[1]}`;
      if (
        orderCategoryValue?.value === "PRJ" ||
        orderCategoryValue?.value === "CPRJ"
      ) {
        if (clientName) {
          setNewCommissionName(
            `${newValue}-${clientName}-${uniqueID}`.toUpperCase(),
          );
        } else {
          setNewCommissionName(`${newValue}-${uniqueID}`.toUpperCase());
        }
      } else {
        if (clientName) {
          setNewCommissionName(
            `${newValue}-${uniqueID}-${clientName}`.toUpperCase(),
          );
        } else {
          setNewCommissionName(`${newValue}-${uniqueID}`.toUpperCase());
        }
      }
    }
  }, [uniqueID, clientName, exitingCommissionName]);
  const isFormValuesValid = useMemo(() => {
    if (!formValues?.length) return true;

    return formValues.every((value) => {
      if (value.range?.label === "NA-ACCESSORY/POS") {
        return true;
      }

      return (
        value.range &&
        Object.keys(value.range).length > 0 &&
        value.color &&
        Object.keys(value.color).length > 0 &&
        value.carcass &&
        Object.keys(value.carcass).length > 0 &&
        value.handle &&
        Object.keys(value.handle).length > 0
      );
    });
  }, [formValues]);
  const isValid = useMemo(() => {
    let isCategoryValid = true;

    if (partOrderValue === "exitingOrder") {
      isCategoryValid = !!(
        showroom?.label &&
        product &&
        orderCategoryValue &&
        freight &&
        isFormValuesValid
      );
    } else if (partOrderValue === "newOrder") {
      //console.log(formValues);
      formValues?.every((value) => {
        Object.values(value).every((field) => {
          return true;
        });
        return true;
      });
      isCategoryValid = !!(
        showroom?.label &&
        product &&
        orderCategoryValue &&
        uniqueID &&
        freight &&
        clientName &&
        clientName.length + uniqueID.length <= 21 &&
        //WG1Price &&
        //WG2Price &&
        //!!DRWFile &&
        //(!!appliancesDetail || sharedLater || notApplicable) &&
        //(!!orderCheckFile || drwFileSupersedes) &&
        formValues.every((value) => {
          if (value.range.label === "NA-ACCESSORY/POS") {
            return true;
          } else {
            return Object.values(value).every((field) => {
              return field && Object.keys(field).length > 0;
            });
          }
        })
      );
    }

    return isCategoryValid;
  }, [
    showroom,
    product,
    orderCategoryValue,
    uniqueID,
    clientName,
    WG1Price,
    WG2Price,
    volume,
    DRWFile,
    freight,
    appliancesDetail,
    orderCheckFile,
    drwFileSupersedes,
    sharedLater,
    notApplicable,
    formValues,
    rowData,
  ]);

  useEffect(() => {
    setBtnDisable(!isValid || !isReasonSelected);
  }, [isValid, isReasonSelected]);

  const handlePlaceOrder = async () => {
    setCheckSubmit(true);
    setLoading(true);
    const materialFormData = formValues.flatMap((item, index) => {
      const result = {};
      Object.entries(item).forEach(([key, value]) => {
        const prefix = `${key}${index + 1}`;
        if (key === "priceGroup") {
          result[prefix] = value?.label;
        } else {
          result[`${prefix}Id`] = value?.value;
          result[prefix] = value?.label;
        }
      });
      return result;
    });
    const resultObject = materialFormData.reduce(
      (accumulator, currentObject, index) => {
        Object.entries(currentObject).forEach(([key, value]) => {
          accumulator[key] = value;
        });
        return accumulator;
      },
      {},
    );
    const temp = uploadValue[0].uploadFile ? uploadValue.map((i) => i.id) : [];
    const updatedRowData = updateData.map((item) => {
      const { imgUpldReqd, postnNumReqd, rowIndex, ...rest } = item;
      return rest;
    });

    let payload = {};
    if (partOrderValue === "exitingOrder") {
      payload = {
        ...resultObject,
        customerId: getOrder.customerNo,
        showroomId: showroom.value,
        orderCategory: getOrder.orderCategory,
        docType: "AO",
        vendorId: getOrder.vendor,
        vendor: getOrder.vendorName,
        commissionName: newCommissionName
          ? newCommissionName
          : getOrder.commissionName,
        orderRef: getOrder.project.substring(
          0,
          getOrder.project.length === 10 ? 7 : 6,
        ),
        specialComments: comment?.toUpperCase(),
        vendorShortKey: getOrder.vendorShortKey,
        typeName: getOrder.project.substring(
          getOrder.project.length === 10 ? 7 : 6,
        ),
        projectUniqueId: uniqueID ? uniqueID.toUpperCase() : getOrder?.uniqueid,
        projectClient: getOrder?.client,
        // companyId: 0,
        sharedLater: sharedLater,
        na: notApplicable,
        drawFileSupersedes: drwFileSupersedes,
        drwFile: drwFileId,
        applianceDetail: appliancesDetailFileId,
        orderCheckList: orderCheckFileId,
        freightId: freight.id,
        freight: freight.value,
        // drawingFile: firstFileId,
        orderFiles: temp,
        partForExistingOrder: true,
        newPartOrder: false,
        parentABNumber: getOrder.abNumber,
        partOrderDetails: updatedRowData,
      };
    } else if (partOrderValue === "newOrder") {
      payload = {
        ...resultObject,
        customerId: hasSupperUser ? selectedPartner?.value : customerId,
        showroomId: showroom.value,
        orderCategory: orderCategoryValue?.value,
        docType: "AO",
        wg1: WG1Price,
        wg2: WG2Price,
        volume: volume,
        weight: weight,
        vendorId: product.id,
        vendor: product.label,
        projectTypeNum: Number(typeNumber),
        projectUniqueId: uniqueID?.toUpperCase(),
        projectClient: clientName?.toUpperCase(),
        commissionName: commissionName,
        orderRef: orderReference,
        specialComments: comment?.toUpperCase(),
        typeName: typeNumber,
        companyId: hasSupperUser ? selectedPartner?.value : customerId,
        sharedLater: sharedLater,
        na: notApplicable,
        drawFileSupersedes: drwFileSupersedes,
        drwFile: drwFileId,
        applianceDetail: appliancesDetailFileId,
        orderCheckList: orderCheckFileId,
        // drawingFile: firstFileId,
        orderFiles: temp,
        customerProjectNum: 0,
        partForExistingOrder: false,
        newPartOrder: true,
        freightId: freight.id,
        freight: freight.value,
        parentABNumber: getOrder.abNumber,
        partOrderDetails: updatedRowData,
        loadingWeek: loadingWeek?.value,
      };
    }
    // console.log("rowData", payload);
    try {
      await OAuthService.addData(newPartOrderUrl, payload).then((list) => {
        const data = list.data;
        setCurrentOrder(data);
      });
      setOpenSuccessOrder(true);
      setCheckSubmit(false);
      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || error.message);
      setLoading(false);
      return;
    }
  };

  const placeOrder = () => {
    return (
      <Button
        variant="contained"
        onClick={handlePlaceOrder}
        color="secondary"
        disabled={btnDisable || loading}
      >
        Place Order
      </Button>
    );
  };

  const [currentPage, setCurrentPage] = useState(0);
  const [currentQuery, setCurrentQuery] = useState("");

  const getAbOptions = async (query, page) => {
    const size = 30;
    if (query !== currentQuery) {
      setCurrentPage(0);
      page = 0;
      setCurrentQuery(query);
    }
    const result = await getAbNumber(query, page, size);

    if (result.hasMore) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
    return result;
  };

  const getCommissionOptions = async (query, page) => {
    const size = 30;
    if (query !== currentQuery) {
      setCurrentPage(0);
      page = 0;
      setCurrentQuery(query);
    }
    const result = await getCommissionName(query, page, size);

    if (result.hasMore) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
    return result;
  };

  const getCustomer = async () => {
    const list = await OAuthService.getList(
      companiesUrl +
        `/search/findActiveByCustomerTypes?&customerTypes=REGULAR&customerTypes=WHOLESALE&page=0&sort=id,ase,&size=1000`,
    );
    let companies = list.data?._embedded?.companies;
    companies = companies.map((company) => {
      return {
        value: company.id,
        label: `${company?.id}-${company?.shortKey}-${company?.countryName}`,
      };
    });
    setCustomerOptions(companies);
    if (customerId) {
      const defaultCustomer = companies.find((item) => item.id === customerId);
      setCustomerName(defaultCustomer);
    }
  };

  const getShowroom = async () => {
    try {
      if (Number(customerName.value)) {
        const showroomByCompanyUrl = `${companiesUrl}/${customerName.value}/showrooms`;
        const list = await OAuthService.getList(showroomByCompanyUrl);
        let showrooms = list.data?._embedded?.showrooms;
        showrooms = showrooms.map((showroom) => {
          return {
            value: showroom.id,
            label: showroom.name,
          };
        });
        setShowroomOptions(showrooms);
      }
    } catch (error) {
      toast.error("Showroom data not available");
      //toast.error(error.message);
    }
  };

  useEffect(() => {
    if (hasNolteSopRole || hasSupperUser) {
      getCustomer();
    }
  }, [hasNolteSopRole, hasSupperUser]);

  useEffect(() => {
    if (customerName) {
      getShowroom();
    }
  }, [customerName, hasNolteSopRole, hasSupperUser]);

  return (
    <>
      <ListPageHeader
        componentName="Create Part Order"
        pageName="Create Part Order"
        showPaginationDropdown={showPaginationDropdown}
        placeOrder={placeOrder()}
        snackState={snackState}
        error={error}
        successMsg={successMsg}
      />
      {/* <PartOrderBasicInfo /> */}
      <div className="px-20">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              className="mt-20"
              sx={{
                px: 2,
                border: `1px dashed ${theme.palette.divider}`,
                borderRadius: 4,
              }}
              sx={{
                px: 2,
                border: `1px dashed ${theme.palette.divider}`,
                borderRadius: 4,
              }}
            >
              <RadioGroup
                row
                value={partOrderValue}
                onChange={handlePartOrderChange}
              >
                <FormControlLabel
                  value="exitingOrder"
                  control={<Radio />}
                  label="PART FOR EXISTING ORDER"
                />
                <FormControlLabel
                  value="newOrder"
                  control={<Radio />}
                  label="PART ORDER NEW"
                />
              </RadioGroup>
            </Box>
          </Grid>
          {partOrderValue === "exitingOrder" && (
            <>
              <Grid item xs={12} md={6}>
                <Box
                  className="mb-20"
                  sx={{
                    p: 2,
                    border: `1px dashed ${theme.palette.divider}`,
                    borderRadius: 4,
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                      <label className="pb-8 block">AB Number</label>
                      <AsyncPaginate
                        value={selectedAbNumber || defaultSelectedAbNumber}
                        loadOptions={(inputValue, _, { page }) =>
                          getAbOptions(inputValue, page)
                        }
                        getOptionValue={(option) => option.orderId}
                        getOptionLabel={(option) => option.abNumber}
                        onChange={handleAbNumberChange}
                        styles={customStyles()}
                        className="w-full"
                        isSearchable
                        additional={{
                          page: currentPage,
                        }}
                      />
                      {/* <Select
                        options={abNumberOption}
                        value={selectedAbNumber || defaultSelectedAbNumber}
                        onInputChange={handleInputAbNumber}
                        onChange={handleAbNumberChange}
                        isSearchable
                        styles={customStyles()}
                        className="w-full"
                      /> */}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">Commission Name</label>
                      <AsyncPaginate
                        value={
                          selectedCommissionNumber ||
                          defaultSelectedCommissionNumber
                        }
                        loadOptions={(inputValue, _, { page }) =>
                          getCommissionOptions(inputValue, page)
                        }
                        getOptionValue={(option) => option.orderId}
                        getOptionLabel={(option) => option.commissionName}
                        onChange={handleCommissionChange}
                        styles={customStyles()}
                        className="w-full"
                        isSearchable
                        additional={{
                          page: currentPage,
                        }}
                      />
                      {/* <Select
                        options={commissionNumberOption}
                        styles={customStyles()}
                        className="w-full"
                        isSearchable
                        value={
                          selectedCommissionNumber ||
                          defaultSelectedCommissionNumber
                        }
                        onInputChange={handleInputCommission}
                        onChange={handleCommissionChange}
                      /> */}
                    </Grid>
                    <Grid item xs={12} sm={5}>
                      <label className="pb-8 block">Customer</label>
                      <TextField
                        name="customer"
                        fullWidth
                        variant="outlined"
                        type="text"
                        value={customerName}
                        disabled
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} className="mt-10">
                    <Grid item xs={12} sm={6} md={3}>
                      <label className="pb-8 block">Unique ID</label>
                      <TextField
                        name="uniqueID"
                        value={uniqueID}
                        onChange={handleUniqueIDChange}
                        fullWidth
                        variant="outlined"
                        type="text"
                        inputProps={{
                          maxLength: maxUniqueIdLength,
                          style: { textTransform: "uppercase" },
                        }}
                        error={
                          lastEdited === "uniqueID" &&
                          uniqueID.length + clientName.length > 20
                        }
                        helperText={
                          lastEdited === "uniqueID" &&
                          uniqueID.length + clientName.length > 20 &&
                          `Total characters (Client Name + Unique ID) must be 21 or less`
                        }
                      />
                      {/* <TextField
                        name="uniqueID"
                        value={uniqueID}
                        onChange={handleUniqueIDChange}
                        fullWidth
                        variant="outlined"
                        type="text"
                        inputProps={{ maxLength: 20 - clientName?.length }}
                        helperText={
                          uniqueID.length > 19 &&
                          "This field characters should be less then 20"
                        }
                      /> */}
                    </Grid>

                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">Client Name</label>
                      <TextField
                        name="customer"
                        fullWidth
                        variant="outlined"
                        type="text"
                        value={clientName}
                        disabled
                      />
                    </Grid>

                    <Grid item xs={12} sm={5}>
                      <label className="pb-8 block">New Commission Name</label>
                      <TextField
                        name="customer"
                        fullWidth
                        variant="outlined"
                        type="text"
                        value={newCommissionName}
                        disabled
                        inputProps={{ style: { textTransform: "uppercase" } }}
                      />
                    </Grid>
                  </Grid>
                </Box>
                <Box
                  className="mb-20 mt-20"
                  sx={{
                    p: 2,
                    border: `1px dashed ${theme.palette.divider}`,
                    borderRadius: 4,
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">
                        Original Order Placement Date
                      </label>
                      <TextField
                        name="customer"
                        fullWidth
                        variant="outlined"
                        type="text"
                        value={orderPlacementDate || "-"}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">
                        Original Order Loading Week
                      </label>
                      <TextField
                        name="customer"
                        fullWidth
                        variant="outlined"
                        type="text"
                        value={orderLoadingDate || "-"}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">*Freight</label>
                      <Select
                        value={freight}
                        onChange={(event) =>
                          setFreight({
                            id: event.id,
                            value: event.value,
                            label: event.label,
                          })
                        }
                        name="freight"
                        options={freightOptions}
                        styles={customStyles(
                          ((checksubmit && !freight) || validError.freight) &&
                            theme.palette.error.main,
                        )}
                        className="w-full"
                      />
                      <Typography
                        sx={{
                          color: theme.palette.error.main,
                          fontSize: "0.875rem",
                          ml: 1.75,
                        }}
                      >
                        {checksubmit && !freight
                          ? "This field is required"
                          : validError.freight}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <label className="pb-8 block">Special Comments</label>
                      <TextField
                        multiline
                        value={comment}
                        inputProps={{ style: { textTransform: "uppercase" } }}
                        onChange={(e) => setComment(e.target.value)}
                        name="comment"
                        fullWidth
                        rows={2}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box
                  className="mb-20"
                  sx={{
                    p: 2,
                    border: `1px dashed ${theme.palette.divider}`,
                    borderRadius: 4,
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">Showroom</label>
                      <Select
                        required
                        options={showroomOptions}
                        value={showroom}
                        onChange={(event) =>
                          setShowroom({
                            value: event.value,
                            label: event.label,
                          })
                        }
                        styles={customStyles()}
                        className="w-full"
                        isDisabled={!hasCustomerNo}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">Product</label>
                      <Select
                        required
                        options={vendorOptions}
                        value={product}
                        onChange={(event) => {
                          setProduct({
                            value: event.value,
                            label: event.label,
                            id: event.id,
                          });
                        }}
                        styles={customStyles()}
                        className="w-full"
                        isDisabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">Order Category</label>
                      <Select
                        required
                        options={orderCategoryOptions}
                        value={orderCategoryValue}
                        onChange={(event) => {
                          setOrderCategoryValue({
                            value: event.value,
                            label: event.label,
                          });
                        }}
                        styles={customStyles()}
                        className="w-full"
                        isDisabled
                      />
                    </Grid>
                  </Grid>
                </Box>
                <Box
                  className="shadow mb-20 mt-20"
                  style={{
                    backgroundColor: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                  }}
                  sx={{
                    // backgroundColor: "#2A2E32",
                    p: 2,
                    position: "relative",
                    borderRadius: "1.6rem",
                    borderBottomRightRadius: 0,
                    mb: 2.5,
                    width: "100%",
                    boxShadow: theme.shadows[1],
                  }}
                >
                  {formValues.map((element, index) => (
                    <React.Fragment key={index}>
                      <Grid
                        container
                        spacing={2}
                        className={index ? "mt-4 relative" : "relative"}
                        sx={{ position: "relative" }}
                      >
                        <Grid item xs={12} sm={6} md={3}>
                          <label className="pb-8 flex">Range</label>
                          <Select
                            value={formValues?.[index]?.range}
                            onChange={(e) =>
                              handleRangeChange(e, index, "range")
                            }
                            name="range"
                            options={range}
                            styles={customStyles()}
                            className="w-full"
                          />
                        </Grid>

                        {selectedRange?.id !== "65802d523551a91878ba1992" && (
                          <>
                            <Grid item xs={12} sm={6} md={3}>
                              <label className="pb-8 flex">Color</label>
                              <Select
                                value={formValues?.[index]?.color}
                                onChange={(e) =>
                                  handleRangeChange(e, index, "color")
                                }
                                name="color"
                                options={color[index]}
                                styles={customStyles()}
                                className="w-full"
                              />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                              <label className="pb-8 flex">Carcass</label>
                              <Select
                                value={formValues?.[index]?.carcass}
                                onChange={(e) =>
                                  handleRangeChange(e, index, "carcass")
                                }
                                name="carcass"
                                options={carcass}
                                styles={customStyles()}
                                className="w-full"
                              />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3}>
                              <label className="pb-8 flex">Handle</label>
                              <Select
                                value={formValues?.[index]?.handle}
                                onChange={(e) =>
                                  handleRangeChange(e, index, "handle")
                                }
                                name="handle"
                                options={handles}
                                styles={customStyles()}
                                className="w-full"
                              />
                            </Grid>
                          </>
                        )}

                        {index > 0 && (
                          <IconButton
                            onClick={() => removeFormFields(index)}
                            color="secondary"
                            sx={{
                              position: "absolute",
                              right: { xs: 0, md: "-30px" },
                              top: { xs: 0, md: "auto" },
                              bottom: { xs: "auto", md: 4 },
                            }}
                          >
                            <FuseSvgIcon size={16}>
                              heroicons-outline:x
                            </FuseSvgIcon>
                          </IconButton>
                        )}
                      </Grid>
                    </React.Fragment>
                  ))}
                  {formValues.length < 3 && (
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => addFormFields()}
                      size="small"
                      sx={{
                        position: "absolute",
                        bottom: "-32px",
                        right: 0,
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0,
                      }}
                    >
                      <FuseSvgIcon>heroicons-outline:plus</FuseSvgIcon>
                    </Button>
                  )}
                </Box>
              </Grid>
            </>
          )}
          {partOrderValue === "newOrder" && (
            <>
              <Grid item xs={12} md={6}>
                <Box
                  className="mb-20"
                  sx={{
                    p: 2,
                    border: `1px dashed ${theme.palette.divider}`,
                    borderRadius: 4,
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <label className="pb-8 block">*Partner</label>
                      {hasSupperUser ? (
                        <Select
                          placeholder={"Select Partner"}
                          name="partner"
                          value={selectedPartner}
                          options={customerOptions}
                          onChange={(event) => {
                            setSelectedPartner({
                              value: event.value,
                              label: event.label,
                            });
                            setShowroom(null);
                            setOrderCategoryValue(null);
                            setProduct(null);
                          }}
                          styles={customStyles()}
                          className="select"
                        />
                      ) : (
                        <TextField
                          name="customer"
                          fullWidth
                          variant="outlined"
                          type="text"
                          value={customerName}
                          disabled
                        />
                      )}
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label className="pb-8 block">*Showroom</label>
                      <Select
                        value={showroom}
                        onChange={(event) =>
                          setShowroom({
                            value: event.value,
                            label: event.label,
                          })
                        }
                        name="showroom"
                        options={showroomOptions}
                        styles={customStyles()}
                        className="select"
                        // isDisabled={token.scope.includes(
                        //   "ROLE_PARTNRORDPROCESS"
                        // )}
                      />
                    </Grid>
                  </Grid>
                </Box>
                <Box
                  className="mb-20"
                  sx={{
                    p: 2,
                    border: `1px dashed ${theme.palette.divider}`,
                    borderRadius: 4,
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">Type Number</label>
                      <TextField
                        value={typeNumber}
                        name="typeNumber"
                        fullWidth
                        variant="outlined"
                        type="text"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">*Unique ID</label>
                      <TextField
                        name="uniqueID"
                        value={uniqueID}
                        onChange={handleUniqueIDChange}
                        fullWidth
                        variant="outlined"
                        color="secondary"
                        type="text"
                        inputProps={{
                          maxLength: maxUniqueIdLength,
                          style: { textTransform: "uppercase" },
                        }}
                        error={
                          lastEdited === "uniqueID" &&
                          uniqueID.length + clientName.length > 20
                        }
                        helperText={
                          lastEdited === "uniqueID" &&
                          uniqueID.length + clientName.length > 20 &&
                          `Total characters (Client Name + Unique ID) must be 21 or less`
                        }
                      />
                      {/* <TextField
                        name="uniqueID"
                        value={uniqueID}
                        onChange={handleUniqueIDChange}
                        fullWidth
                        variant="outlined"
                        type="text"
                        inputProps={{ maxLength: 20 - clientName?.length }}
                        helperText={
                          uniqueID.length > 19 &&
                          "This field characters should be less then 20"
                        }
                      /> */}
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">*Client Name</label>
                      {/* <TextField
                        value={clientName}
                        onChange={handleClientNameChange}
                        name="clientName"
                        fullWidth
                        variant="outlined"
                        type="text"
                        inputProps={{ maxLength: 20 - uniqueID?.length }}
                        helperText={
                          clientName.length > 19 &&
                          "This field characters should be less then 20"
                        }
                      /> */}
                      <TextField
                        value={clientName}
                        onChange={handleClientNameChange}
                        name="clientName"
                        fullWidth
                        variant="outlined"
                        type="text"
                        inputProps={{
                          maxLength: maxClientNameLength,
                          style: { textTransform: "uppercase" },
                        }}
                        error={
                          lastEdited === "clientName" &&
                          uniqueID.length + clientName.length > 20
                        }
                        helperText={
                          lastEdited === "clientName" &&
                          uniqueID.length + clientName.length > 20 &&
                          `Total characters (Client Name + Unique ID) must be 21 or less`
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <label className="pb-8 block">Commission Name</label>
                      <TextField
                        value={commissionName}
                        name="commissionName"
                        fullWidth
                        variant="outlined"
                        type="text"
                        disabled
                        inputProps={{ style: { textTransform: "uppercase" } }}
                      />
                    </Grid>
                  </Grid>
                </Box>
                <Box
                  className="mb-20"
                  sx={{
                    p: 2,
                    border: `1px dashed ${theme.palette.divider}`,
                    borderRadius: 4,
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <label className="pb-8 block">Volume(cbm)</label>
                      <TextField
                        value={volume}
                        onChange={(e) => {
                          const inputValue = e.target.value.replace(
                            /[^\d.]/g,
                            "",
                          );
                          setVolume(inputValue);
                        }}
                        onKeyDown={blockInvalidKeys}
                        name="volume"
                        fullWidth
                        variant="outlined"
                        type="number"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <label className="pb-8 block">Weight (kg)</label>
                      <TextField
                        value={weight}
                        onChange={(e) => {
                          const inputValue = e.target.value.replace(
                            /[^\d.]/g,
                            "",
                          );
                          setWeight(inputValue);
                        }}
                        onKeyDown={blockInvalidKeys}
                        name="weight"
                        fullWidth
                        variant="outlined"
                        type="number"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <label className="pb-8 block">Special Comments</label>
                      <TextField
                        multiline
                        value={comment}
                        inputProps={{ style: { textTransform: "uppercase" } }}
                        onChange={(e) => setComment(e.target.value)}
                        name="comment"
                        fullWidth
                        rows={2}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box
                  className="mb-20"
                  sx={{
                    p: 2,
                    border: `1px dashed ${theme.palette.divider}`,
                    borderRadius: 4,
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">*Product</label>
                      <Select
                        value={product}
                        onChange={(event) => {
                          setProduct({
                            value: event.value,
                            label: event.label,
                            id: event.id,
                          });
                          resetFormValues();
                        }}
                        name="product"
                        options={productOptions}
                        styles={customStyles()}
                        className="w-full"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">*Order Category</label>
                      <Select
                        required
                        value={orderCategoryValue}
                        options={orderCategoryOptions}
                        styles={customStyles()}
                        className="w-full"
                        onChange={handleChangeOrderCategory}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">Order Reference</label>
                      <TextField
                        value={orderReference}
                        name="orderReference"
                        fullWidth
                        variant="outlined"
                        type="text"
                        disabled
                      />
                    </Grid>
                  </Grid>
                </Box>
                <Box
                  className="mb-20"
                  sx={{
                    p: 2,
                    border: `1px dashed ${theme.palette.divider}`,
                    borderRadius: 4,
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">
                        *WG1 List Price (Euros)
                      </label>
                      <TextField
                        value={WG1Price}
                        onChange={(e) => {
                          const inputValue = e.target.value.replace(
                            /[^0-9.]/g,
                            "",
                          );
                          setWG1Price(inputValue);
                        }}
                        onKeyDown={blockInvalidKeys}
                        name="WG1Price"
                        fullWidth
                        variant="outlined"
                        type="number"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">
                        *WG2 List Price (Euros)
                      </label>
                      <TextField
                        value={WG2Price}
                        onChange={(e) => {
                          const inputValue = e.target.value.replace(
                            /[^0-9.]/g,
                            "",
                          );
                          setWG2Price(inputValue);
                        }}
                        onKeyDown={blockInvalidKeys}
                        name="WG2Price"
                        fullWidth
                        variant="outlined"
                        type="number"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">
                        Total List Price (Euros){" "}
                      </label>
                      <Box
                        sx={{
                          padding: "4px 10px",
                          borderRadius: "4px",
                          backgroundColor: theme.palette.action.hover,
                          border: `1px solid ${theme.palette.divider}`,
                          color: theme.palette.text.primary,
                        }}
                      >
                        {totalListPrice()}
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                <Box
                  className="mb-20 mt-20"
                  sx={{
                    p: 2,
                    border: `1px dashed ${theme.palette.divider}`,
                    borderRadius: 4,
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">Container No</label>
                      <TextField
                        value={containerNo}
                        inputProps={{ style: { textTransform: "uppercase" } }}
                        onChange={(e) => setContainerNo(e.target.value)}
                        name="containerNo"
                        fullWidth
                        variant="outlined"
                        type="text"
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">Loading Week</label>
                      <Select
                        value={loadingWeek}
                        onChange={(event) =>
                          setLoadingWeek({
                            value: event.value,
                            label: event.label,
                          })
                        }
                        name="loadingWeek"
                        options={filterLoadingWeekOptions}
                        styles={customStyles()}
                        className="w-full"
                        isDisabled={sharedLater}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <label className="pb-8 block">*Freight</label>
                      <Select
                        value={freight}
                        onChange={(event) =>
                          setFreight({
                            id: event.id,
                            value: event.value,
                            label: event.label,
                          })
                        }
                        name="freight"
                        options={freightOptions}
                        styles={customStyles(
                          ((checksubmit && !freight) || validError.freight) &&
                            theme.palette.error.main,
                        )}
                        className="w-full"
                      />
                      <Typography
                        sx={{
                          color: theme.palette.error.main,
                          fontSize: "0.875rem",
                          ml: 1.75,
                        }}
                      >
                        {checksubmit && !freight
                          ? "This field is required"
                          : validError.freight}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box
                  className="shadow mb-20 mt-20"
                  style={{
                    backgroundColor: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                  }}
                  sx={{
                    // backgroundColor: "#2A2E32",
                    p: 2,
                    position: "relative",
                    borderRadius: "1.6rem",
                    borderBottomRightRadius: 0,
                    mb: 2.5,
                    width: "100%",
                    boxShadow: theme.shadows[1],
                  }}
                >
                  {formValues.map((element, index) => (
                    <>
                      <Grid
                        container
                        spacing={2}
                        className={index ? "mt-4 relative" : "relative"}
                      >
                        <Grid item xs={12} sm={6} md={3}>
                          <label className="pb-8 flex">*Range</label>
                          <Select
                            value={formValues?.[index]?.range}
                            onChange={(e) =>
                              handleRangeChange(e, index, "range")
                            }
                            name="range"
                            options={range}
                            styles={customStyles()}
                            className="w-full"
                          />
                        </Grid>
                        {selectedRange?.id !== "65802d523551a91878ba1992" && (
                          <>
                            <Grid item xs={12} sm={6} md={3}>
                              <label className="pb-8 flex">*Color</label>
                              <Select
                                value={formValues?.[index]?.color}
                                onChange={(e) =>
                                  handleRangeChange(e, index, "color")
                                }
                                name="color"
                                options={color[index]}
                                styles={customStyles()}
                                className="w-full"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                              <label className="pb-8 flex">Carcass</label>
                              <Select
                                value={formValues?.[index]?.carcass}
                                onChange={(e) =>
                                  handleRangeChange(e, index, "carcass")
                                }
                                name="carcass"
                                options={carcass}
                                styles={customStyles()}
                                className="w-full"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                              <label className="pb-8 flex">*Handle</label>
                              <Select
                                value={formValues?.[index]?.handle}
                                onChange={(e) =>
                                  handleRangeChange(e, index, "handle")
                                }
                                name="handle"
                                options={handles}
                                styles={customStyles()}
                                className="w-full"
                              />
                            </Grid>
                          </>
                        )}
                        {index ? (
                          <IconButton
                            color="secondary"
                            onClick={() => removeFormFields(index)}
                            sx={{
                              position: "absolute",
                              right: { xs: 0, md: "-30px" },
                              top: { xs: 0, md: "auto" },
                              bottom: { xs: "auto", md: 4 },
                            }}
                          >
                            <FuseSvgIcon size={14}>
                              heroicons-outline:x
                            </FuseSvgIcon>
                          </IconButton>
                        ) : null}
                      </Grid>
                    </>
                  ))}
                  {formValues.length < 3 && (
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => addFormFields()}
                      size="small"
                      sx={{
                        position: "absolute",
                        bottom: "-32px",
                        right: 0,
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0,
                      }}
                    >
                      <FuseSvgIcon>heroicons-outline:plus</FuseSvgIcon>
                    </Button>
                  )}
                </Box>
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <Button
              variant="contained"
              onClick={() => onBtAdd(undefined)}
              color="secondary"
              disabled={disableAddBtn}
            >
              Add
            </Button>
            <Box
              className="mb-20 mt-10"
              sx={{
                p: 2,
                border: `1px dashed ${theme.palette.divider}`,
                borderRadius: 4,

                "& .ag-cell.custom-style": {
                  backgroundColor: alpha(theme.palette.warning.main, 0.15),
                  borderColor: theme.palette.warning.main,
                },
              }}
            >
               <div style={{ height: 250, width: "100%" }} className="relative">
                <AgGridTable
                  columnDefs={columnDefs}
                  onGridReady={onGridReady}
                  gridRef={gridRef}
                  rowData={rowData}
                  rowGroupPanelShow={"never"}
                  onCellValueChanged={onCellValueChanged}
                  // onRowValueChanged={onRowValueChanged}
                  hideCheckbox={true}
                  editable={false}
                  rowHeight={30}
                  // singleClickEdit={true}
                  // editType={'fullRow'}
                />
              </div>
            </Box>
          </Grid>
          <Container
            component="main"
            maxWidth="md"
            sx={{ py: 3, px: { xs: 2, md: 3 } }}
          >
            <Grid container spacing={1} sx={{ position: "relative" }}>
              <Grid item xs={12} sm={6} md={3}>
                <Card>
                  <CardContent>
                    <label className="pb-8 flex">DRW File</label>

                    {getOrder?.drwFile && (
                      <ColorButton
                        sx={{ mb: 1 }}
                        variant="contained"
                        fullWidth
                        onClick={() =>
                          handleDownloadFile(DRWFile.id, DRWFile.attachmentName)
                        }
                      >
                        <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                          heroicons-solid:download
                        </FuseSvgIcon>{" "}
                        Download
                      </ColorButton>
                    )}
                    <ColorButton
                      variant="contained"
                      component="label"
                      disabled={DRWFile}
                    >
                      <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                        heroicons-outline:upload
                      </FuseSvgIcon>{" "}
                      Upload
                      <input
                        type="file"
                        className="file"
                        onChange={handleDRWUpload}
                        ref={hiddenDRWFile}
                        disabled={DRWFile}
                        accept=".drw, .prw"
                      />
                    </ColorButton>
                    {DRWFile && (
                      <Box className="mt-16">
                        <Chip
                          label={DRWFile.name || DRWFile.attachmentName}
                          onDelete={removeDRWFile}
                        />
                      </Box>
                    )}
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Card>
                  <CardContent>
                    <label className="pb-8 flex">Appliances Detail</label>
                    {getOrder.applianceDetail && (
                      <ColorButton
                        sx={{ mb: 1 }}
                        variant="contained"
                        fullWidth
                        onClick={() =>
                          handleDownloadFile(
                            appliancesDetail.id,
                            appliancesDetail.attachmentName,
                          )
                        }
                      >
                        <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                          heroicons-solid:download
                        </FuseSvgIcon>{" "}
                        Download
                      </ColorButton>
                    )}
                    <ColorButton
                      variant="contained"
                      component="label"
                      disabled={
                        appliancesDetail || sharedLater || notApplicable
                      }
                    >
                      <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                        heroicons-outline:upload
                      </FuseSvgIcon>{" "}
                      Upload
                      <input
                        type="file"
                        className="file"
                        onChange={handleADUpload}
                        ref={hiddenADFile}
                        disabled={
                          appliancesDetail || sharedLater || notApplicable
                        }
                      />
                    </ColorButton>
                    {appliancesDetail && (
                      <Box className="mt-16">
                        <Chip
                          label={
                            appliancesDetail.name ||
                            appliancesDetail.attachmentName
                          }
                          onDelete={removeADFile}
                        />
                      </Box>
                    )}
                  </CardContent>
                </Card>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={sharedLater}
                        onChange={(event) => {
                          setSharedLater(event.target.checked);
                          setNotApplicable(false);
                        }}
                      />
                    }
                    label="Will be shared later"
                    sx={{ "& span": { fontSize: "11px" } }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={notApplicable}
                        onChange={(event) => {
                          setNotApplicable(event.target.checked);
                          setSharedLater(false);
                        }}
                      />
                    }
                    label="NA"
                    sx={{ "& span": { fontSize: "11px" } }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Card>
                  <CardContent>
                    <label className="pb-8 flex">Order Checklist</label>
                    {getOrder.orderCheckList && (
                      <ColorButton
                        sx={{ mb: 1 }}
                        variant="contained"
                        fullWidth
                        onClick={() =>
                          handleDownloadFile(
                            orderCheckFile.id,
                            orderCheckFile.attachmentName,
                          )
                        }
                      >
                        <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                          heroicons-solid:download
                        </FuseSvgIcon>{" "}
                        Download
                      </ColorButton>
                    )}
                    <ColorButton
                      variant="contained"
                      component="label"
                      disabled={orderCheckFile || drwFileSupersedes}
                    >
                      <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                        heroicons-outline:upload
                      </FuseSvgIcon>{" "}
                      Upload
                      <input
                        type="file"
                        className="file"
                        onChange={handleOrderCheckUpload}
                        ref={hiddenOrderCheckFile}
                        disabled={orderCheckFile || drwFileSupersedes}
                      />
                    </ColorButton>
                    {orderCheckFile && (
                      <Box className="mt-16">
                        <Chip
                          label={
                            orderCheckFile.name || orderCheckFile.attachmentName
                          }
                          onDelete={removeOrderCheckFile}
                        />
                      </Box>
                    )}
                  </CardContent>
                </Card>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={drwFileSupersedes}
                        onChange={(event) =>
                          setDrwFileSupersedes(event.target.checked)
                        }
                      />
                    }
                    label="DRW file supersedes"
                    sx={{ "& span": { fontSize: "11px" } }}
                  />
                </FormGroup>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                {uploadValue.map((element, index) => (
                  <Card sx={{ position: "relative", mb: 1 }}>
                    <CardContent>
                      <label className="pb-8 flex">Drawing File</label>
                      {getOrder.drawingFile && (
                        <ColorButton
                          sx={{ mb: 1 }}
                          variant="contained"
                          fullWidth
                          onClick={() =>
                            handleDownloadFile(
                              drawingFile.id,
                              drawingFile.attachmentName,
                            )
                          }
                        >
                          <FuseSvgIcon
                            size={18}
                            sx={{ display: "inline-block" }}
                          >
                            heroicons-solid:download
                          </FuseSvgIcon>{" "}
                          Download
                        </ColorButton>
                      )}
                      <ColorButton
                        variant="contained"
                        component="label"
                        disabled={
                          uploadValue[index]?.id?.trim().length > 0
                            ? true
                            : false
                        }
                      >
                        <FuseSvgIcon size={18} sx={{ display: "inline-block" }}>
                          heroicons-outline:upload
                        </FuseSvgIcon>{" "}
                        Upload
                        <input
                          type="file"
                          className="file"
                          onChange={(event) =>
                            handleDrawingUpload(event, index)
                          }
                          ref={hiddenDrawingFile}
                          disabled={
                            uploadValue[index]?.id?.trim().length > 0
                              ? true
                              : false
                          }
                        />
                      </ColorButton>
                      {uploadValue[index]?.uploadFile?.name?.length > 0 && (
                        <Box className="mt-16">
                          <Chip
                            label={
                              uploadValue[index]?.uploadFile?.name ||
                              drawingFile.attachmentName
                            }
                            onDelete={() => removeDrawingFile(index)}
                          />
                        </Box>
                      )}
                    </CardContent>
                    {index ? (
                      <IconButton
                        onClick={() => removeUploadFields(index)}
                        size="small"
                        sx={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                        }}
                      >
                        <FuseSvgIcon size={18}>heroicons-outline:x</FuseSvgIcon>
                      </IconButton>
                    ) : null}
                  </Card>
                ))}
              </Grid>
              <IconButton
                variant="contained"
                color="secondary"
                onClick={() => addUploadFields()}
                size="small"
                sx={{
                  marginRight: { xs: 0, md: "-34px" },
                  height: "34px",
                  top: { xs: 0, md: "45px" },
                  ml: { xs: "auto", md: 0 },
                  mt: { xs: 1, md: 0 },
                }}
              >
                <FuseSvgIcon>heroicons-outline:plus</FuseSvgIcon>
              </IconButton>
            </Grid>
          </Container>
        </Grid>
      </div>
      <Box
        sx={{
          display: "flex",
          p: 2,
          justifyContent: "flex-end",
          borderTop: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Button
          variant="contained"
          onClick={handlePlaceOrder}
          color="secondary"
          disabled={btnDisable || loading}
        >
          Place Order
        </Button>
      </Box>
      <OrderSuccess
        open={openSuccessOrder}
        token={token}
        commissionName={commissionName}
        currentOrder={currentOrder}
        setOpenSuccessOrder={setOpenSuccessOrder}
      />
    </>
  );
};

export default PartOrder;
